import React, { useState, useEffect } from 'react';

const KaftoraLogo = () => (
	<svg
		viewBox="0 0 800 800"
		width="100%"
		height="auto"
		xmlns="http://www.w3.org/2000/svg"
		style={{maxWidth: "520px"}}
	>
		{/* Wordmark */}
		<text
			x="400"
			y="420"
			fontSize="110"
			fontWeight="700"
			fill="currentColor"
			textAnchor="middle"
			letterSpacing="3"
			style={{fontFamily: "var(--font-display)"}}
		>
			Kaftora
		</text>

		{/* Needle underline */}
		<rect
			x="180"
			y="424"
			width="444"
			height="5"
			rx="3"
			fill="var(--gold)"
		/>
		<polygon points="181,424 182,430 160,427" fill="var(--gold)" />

		{/* Needle eye */}
		<ellipse cx="636" cy="427" rx="13" ry="4.5" fill="var(--bg)" />
		<ellipse
			cx="636"
			cy="427"
			rx="13"
			ry="4.5"
			fill="none"
			stroke="var(--gold)"
			strokeWidth="2.5"
		/>

		{/* Thread */}
		<path
			d="M649 427 C665 427 675 432 679 442 C683 452 678 465 668 470"
			fill="none"
			stroke="var(--gold)"
			strokeWidth="3"
			strokeLinecap="round"
		/>
		<path
			d="M668 470 C660 480 650 482 645 477"
			fill="none"
			stroke="var(--gold)"
			strokeWidth="2.5"
			strokeLinecap="round"
		/>
	</svg>
);

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
      padding: '0 24px',
      height: '64px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      background: scrolled ? 'rgba(17,17,17,0.97)' : 'transparent',
      borderBottom: scrolled ? '1px solid rgba(240,165,0,0.1)' : '1px solid transparent',
      backdropFilter: scrolled ? 'blur(12px)' : 'none',
      transition: 'all 0.35s ease',
    }}>
      {/* Logo */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }} onClick={() => window.scrollTo({top:0, behavior:'smooth'})}>
        <KaftoraLogo />
      </div>

      {/* Desktop nav */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '32px' }} className="desktop-nav">
        {['how-it-works', 'why-kaftora', 'waitlist'].map((id) => (
          <button key={id} onClick={() => scrollTo(id)} style={{
            background: 'none', border: 'none', color: 'rgba(255,255,255,0.55)',
            fontSize: '0.85rem', fontFamily: 'var(--font-sans)', cursor: 'pointer',
            letterSpacing: '0.05em', textTransform: 'capitalize',
            transition: 'color 0.2s',
          }}
          onMouseEnter={e => e.target.style.color = '#F0A500'}
          onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.55)'}
          >
            {id === 'how-it-works' ? 'How It Works' : id === 'why-kaftora' ? 'Why Kaftora' : 'Join Waitlist'}
          </button>
        ))}
        <button onClick={() => scrollTo('waitlist')} style={{
          background: 'var(--gold)', color: '#000',
          border: 'none', borderRadius: '6px',
          padding: '10px 22px',
          fontSize: '0.85rem', fontWeight: '600', fontFamily: 'var(--font-sans)',
          cursor: 'pointer', letterSpacing: '0.05em',
          transition: 'all 0.2s',
        }}
        onMouseEnter={e => { e.target.style.background = '#FFD166'; e.target.style.transform = 'translateY(-1px)'; }}
        onMouseLeave={e => { e.target.style.background = 'var(--gold)'; e.target.style.transform = 'translateY(0)'; }}
        >
          Join Waitlist
        </button>
      </div>

      {/* Mobile hamburger */}
      <button onClick={() => setMenuOpen(!menuOpen)} style={{
        display: 'none', background: 'none', border: 'none',
        cursor: 'pointer', padding: '4px',
        flexDirection: 'column', gap: '5px',
      }} className="hamburger">
        {[0,1,2].map(i => (
          <span key={i} style={{
            display: 'block', width: '22px', height: '2px',
            background: '#F0A500', borderRadius: '2px',
            transition: 'all 0.3s',
            transform: menuOpen && i === 0 ? 'rotate(45deg) translate(5px, 5px)' : menuOpen && i === 2 ? 'rotate(-45deg) translate(5px, -5px)' : 'none',
            opacity: menuOpen && i === 1 ? 0 : 1,
          }} />
        ))}
      </button>

      {/* Mobile menu */}
      {menuOpen && (
        <div style={{
          position: 'absolute', top: '64px', left: 0, right: 0,
          background: 'rgba(17,17,17,0.98)', backdropFilter: 'blur(12px)',
          borderBottom: '1px solid rgba(240,165,0,0.15)',
          padding: '20px 24px',
          display: 'flex', flexDirection: 'column', gap: '16px',
        }}>
          {['How It Works', 'Why Kaftora', 'Join Waitlist'].map((label, i) => (
            <button key={i} onClick={() => scrollTo(['how-it-works','why-kaftora','waitlist'][i])} style={{
              background: 'none', border: 'none', color: '#fff',
              fontSize: '1rem', fontFamily: 'var(--font-sans)',
              cursor: 'pointer', textAlign: 'left', padding: '4px 0',
            }}>{label}</button>
          ))}
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .hamburger { display: flex !important; }
        }
      `}</style>
    </nav>
  );
}
